(function () {
  if (window.__odditQuickAddInit) return;
  window.__odditQuickAddInit = true;

  var BLOCK = 'oddit-quick-add';
  var BODY_LOCK = 'oddit-quick-add-open';

  var modal = null;
  var lastTrigger = null;
  var currentData = null;
  var selectedVariantId = null;

  function money(value) {
    return typeof value === 'string' ? value : '';
  }

  function parsePayload(trigger) {
    var raw = trigger.getAttribute('data-oddit-quick-add');
    if (!raw) return null;
    try {
      var data = JSON.parse(raw);
      if (!data || !Array.isArray(data.variants) || !data.variants.length) return null;
      return data;
    } catch (e) {
      return null;
    }
  }

  function buildModal() {
    var el = document.createElement('div');
    el.className = BLOCK;
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-labelledby', BLOCK + '-title');
    el.hidden = true;
    el.innerHTML =
      '<div class="' + BLOCK + '__backdrop" data-quick-add-close></div>' +
      '<div class="' + BLOCK + '__sheet" role="document">' +
      '<button type="button" class="' + BLOCK + '__close" data-quick-add-close aria-label="Close">' +
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M2.5 2.5l11 11M13.5 2.5l-11 11" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/>' +
      '</svg></button>' +
      '<div class="' + BLOCK + '__header">' +
      '<div class="' + BLOCK + '__header-image" data-quick-add-image></div>' +
      '<h2 class="' + BLOCK + '__title" id="' + BLOCK + '-title" data-quick-add-title></h2>' +
      '</div>' +
      '<p class="' + BLOCK + '__heading" data-quick-add-heading></p>' +
      '<div class="' + BLOCK + '__options" data-quick-add-options role="radiogroup"></div>' +
      '<p class="' + BLOCK + '__error" data-quick-add-error hidden></p>' +
      '<button type="button" class="' + BLOCK + '__submit" data-quick-add-submit></button>' +
      '<a class="' + BLOCK + '__details" data-quick-add-details>View full details</a>' +
      '</div>';

    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-quick-add-close]')) {
        close();
        return;
      }
      var option = e.target.closest('[data-quick-add-option]');
      if (option && !option.hasAttribute('data-unavailable')) {
        select(option.getAttribute('data-variant-id'));
        return;
      }
      if (e.target.closest('[data-quick-add-submit]')) {
        submit();
      }
    });

    el.addEventListener('keydown', function (e) {
      var option = e.target.closest('[data-quick-add-option]');
      if (!option) return;
      if (e.key === ' ' || e.key === 'Enter' || e.keyCode === 32 || e.keyCode === 13) {
        e.preventDefault();
        if (!option.hasAttribute('data-unavailable')) select(option.getAttribute('data-variant-id'));
      }
    });

    document.body.appendChild(el);
    return el;
  }

  function optionMarkup(variant, data) {
    var classes = BLOCK + '__option';
    if (!variant.available) classes += ' ' + BLOCK + '__option--unavailable';
    if (variant.recommended) classes += ' ' + BLOCK + '__option--recommended';

    var badge =
      variant.recommended && data.recommendedLabel
        ? '<span class="' + BLOCK + '__option-badge">' + escapeHtml(data.recommendedLabel) + '</span>'
        : '';

    var thumb = variant.image
      ? '<span class="' + BLOCK + '__option-thumb"><img src="' + escapeHtml(variant.image) + '" alt="" loading="lazy" width="56" height="56"></span>'
      : '';

    var compare = variant.compareAtPrice
      ? '<s class="' + BLOCK + '__option-compare">' + escapeHtml(money(variant.compareAtPrice)) + '</s> '
      : '';

    var tagline = variant.tagline
      ? '<span class="' + BLOCK + '__option-tagline">' + escapeHtml(variant.tagline) + '</span>'
      : '';

    var unavailable = !variant.available
      ? '<span class="' + BLOCK + '__option-soldout">Sold out</span>'
      : '';

    return (
      '<div class="' + classes + '"' +
      ' data-quick-add-option data-variant-id="' + escapeHtml(String(variant.id)) + '"' +
      (variant.available ? ' tabindex="0"' : ' data-unavailable aria-disabled="true"') +
      ' role="radio" aria-checked="false">' +
      badge +
      '<span class="' + BLOCK + '__option-main">' +
      thumb +
      '<span class="' + BLOCK + '__option-text">' +
      '<span class="' + BLOCK + '__option-row">' +
      '<span class="' + BLOCK + '__option-name">' + escapeHtml(variant.title) + '</span>' +
      '<span class="' + BLOCK + '__option-price">' + compare + escapeHtml(money(variant.price)) + '</span>' +
      '</span>' +
      tagline +
      unavailable +
      '</span>' +
      '</span>' +
      '<span class="' + BLOCK + '__option-radio" aria-hidden="true"></span>' +
      '</div>'
    );
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function select(variantId) {
    if (!variantId) return;
    selectedVariantId = String(variantId);

    var options = modal.querySelectorAll('[data-quick-add-option]');
    for (var i = 0; i < options.length; i++) {
      var isSelected = options[i].getAttribute('data-variant-id') === selectedVariantId;
      options[i].classList.toggle(BLOCK + '__option--selected', isSelected);
      options[i].setAttribute('aria-checked', isSelected ? 'true' : 'false');
    }

    var submitBtn = modal.querySelector('[data-quick-add-submit]');
    if (submitBtn) submitBtn.disabled = false;
    showError('');
  }

  function showError(message) {
    var error = modal.querySelector('[data-quick-add-error]');
    if (!error) return;
    error.textContent = message || '';
    error.hidden = !message;
  }

  function render(data) {
    currentData = data;
    selectedVariantId = null;

    var image = modal.querySelector('[data-quick-add-image]');
    image.innerHTML = data.image
      ? '<img src="' + escapeHtml(data.image) + '" alt="" width="64" height="64">'
      : '';

    modal.querySelector('[data-quick-add-title]').textContent = data.title || '';
    modal.querySelector('[data-quick-add-heading]').textContent =
      data.heading || data.optionName || '';

    var options = modal.querySelector('[data-quick-add-options]');
    options.setAttribute('aria-label', data.optionName || 'Options');
    options.innerHTML = data.variants
      .map(function (variant) {
        return optionMarkup(variant, data);
      })
      .join('');

    var details = modal.querySelector('[data-quick-add-details]');
    if (data.url) {
      details.href = data.url;
      details.hidden = false;
    } else {
      details.removeAttribute('href');
      details.hidden = true;
    }

    var submitBtn = modal.querySelector('[data-quick-add-submit]');
    submitBtn.textContent = data.submitLabel || 'Add to Cart';
    submitBtn.disabled = true;

    showError('');

    var preferred = null;
    for (var i = 0; i < data.variants.length; i++) {
      if (!data.variants[i].available) continue;
      if (!preferred) preferred = data.variants[i];
      if (data.variants[i].recommended) {
        preferred = data.variants[i];
        break;
      }
    }
    if (preferred) select(preferred.id);
  }

  function open(trigger) {
    var data = parsePayload(trigger);
    if (!data) {
      var href = trigger.getAttribute('data-quick-add-fallback-url');
      if (href) window.location.assign(href);
      return;
    }

    if (!modal) modal = buildModal();

    lastTrigger = trigger;
    render(data);

    modal.hidden = false;
    void modal.offsetWidth;
    modal.classList.add('is-open');
    document.body.classList.add(BODY_LOCK);
    document.addEventListener('keydown', onKeyDown);

    var focusTarget =
      modal.querySelector('[data-quick-add-option].' + BLOCK + '__option--selected') ||
      modal.querySelector('[data-quick-add-close]');
    if (focusTarget) focusTarget.focus();
  }

  function close() {
    if (!modal || modal.hidden) return;
    modal.classList.remove('is-open');
    document.body.classList.remove(BODY_LOCK);
    document.removeEventListener('keydown', onKeyDown);

    var finish = function () {
      modal.hidden = true;
    };

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      finish();
    } else {
      window.setTimeout(finish, 200);
    }

    if (lastTrigger) {
      lastTrigger.focus();
      lastTrigger = null;
    }
  }

  function onKeyDown(e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      close();
      return;
    }
    if (e.key !== 'Tab' && e.keyCode !== 9) return;

    var focusable = modal.querySelectorAll(
      'button:not([disabled]), a[href], [tabindex="0"]'
    );
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function addToCart(variantId) {
    if (window.OdditCartDrawer && typeof window.OdditCartDrawer.addToCart === 'function') {
      return window.OdditCartDrawer.addToCart(Number(variantId), 1);
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    }).then(function (response) {
      if (!response.ok) throw new Error('Add to cart failed');
      window.location.assign('/cart');
      return response.json();
    });
  }

  function submit() {
    if (!selectedVariantId || !currentData) return;

    var submitBtn = modal.querySelector('[data-quick-add-submit]');
    if (!submitBtn || submitBtn.disabled) return;

    submitBtn.disabled = true;
    submitBtn.classList.add(BLOCK + '__submit--loading');

    addToCart(selectedVariantId)
      .then(function () {
        close();
      })
      .catch(function () {
        showError('Sorry, that could not be added to your cart. Please try again.');
      })
      .then(function () {
        submitBtn.disabled = false;
        submitBtn.classList.remove(BLOCK + '__submit--loading');
      });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-oddit-quick-add]');
    if (!trigger) return;
    e.preventDefault();
    open(trigger);
  });
})();
